module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step3_6-7ea5caec4974ef79dfb587fc14af271d.png";